<template>
  <div class="ins-hold">
    <MoreTitle title="机构持股" @click="goPage" />
    <div class="edge-width-padding">
      <ColTable :data="insHoldData">
        <ColTableColumn prop="reportDate" label="报告期" :row-style="{ color: theme['--font-color-3'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
        </ColTableColumn>
        <ColTableColumn prop="total" label="持股家数(家)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.total).isNull() }}</template>
        </ColTableColumn>
        <ColTableColumn prop="holdingNumber" label="持股总数(股)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.holdingNumber).convert() }}</template>
        </ColTableColumn>
        <ColTableColumn prop="holdingRatio" label="占总股本比例(%)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">
            {{ $digitjs(row.holdingRatio).rounded() }}
            <i
              v-if="row.holdingRatioChange < 0"
              class="iconfont icon-xiangxiajiantoucuxiao"
              :style="{ color: theme['--down-color'] }"
            ></i>
            <i
              v-if="row.holdingRatioChange > 0"
              class="iconfont icon-xiangshangjiantoucuxiao"
              :style="{ color: theme['--up-color'] }"
            ></i>
          </template>
        </ColTableColumn>
      </ColTable>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['theme'],
  data() {
    return {
      insHoldData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getInsHoldData()
  },
  methods: {
    async getInsHoldData() {
      const res = await this.$post(this.$api.f10.us + '/summary/inst-hold-statistics', {
        symbol: this.symbol,
        startDate: '1990-01-01'
      })

      this.insHoldData = res.data?.slice(0, 2) ?? []
    },
    goPage() {
      this.$router.push({
        path: '/f10/shareholders',
        query: {
          symbol: this.symbol,
          type: 'institutions'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ins-hold {
  background: var(--bg-color-2);
}
</style>
